import http from "./http.js";

async function getServiceType(id) {
  try {
    const response = await http.get(`service-types/${id}`);
    return {
      title: response.data.title,
    };
  } catch (err) {
    throw err;
  }
}

async function getAllServiceTypes() {
  try {
    const response = await http.get("service-types/");
    return response.data.result.map(i => {
      return {
        id: i.id,
        title: i.title,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function updateServiceType(id, serviceType) {
  try {
    const response = await http.put(`service-types/${id}`, serviceType);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createServiceType(serviceType) {
  try {
    const response = await http.post("service-types", serviceType);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getServiceTypes(page = 1, rowsPerPage = 9, search = "", filter = "") {
  try {
    const response = await http.get(
      `service-types?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectServiceType(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get(
      "service-types/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getServiceType,
  updateServiceType,
  createServiceType,
  selectServiceType,
  getServiceTypes,
  getAllServiceTypes,
};
